import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  name: '',
  email: '',
  profilePic: ''
};

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUserProfile: (state, action) => {
      const { name, email, profilePic } = action.payload;
      state.name = name;
      state.email = email;
      state.profilePic = profilePic;
    },
    clearUserProfile: (state) => {
      state.name = '';
      state.email = '';
      state.profilePic = '';
    }
  }
});

export const { setUserProfile, clearUserProfile } = userSlice.actions;

export default userSlice.reducer;
